import React from 'react'
import useStyles from './ReportsEditList.styles'
import {List, ListItem, ListItemText, ListItemSecondaryAction} from '@material-ui/core'
import usePrefix from 'modules/reports/hooks/prefix'

type Props = {
  items: any[]
  'data-testid': string
}

function ReportsEditList(props: Props) {
  const {items} = props
  const classes = useStyles()
  const p = usePrefix(props['data-testid'])

  return (
    <List className={classes.root} data-testid={p()}>
      {items.map((item, index) => (
        <ListItem key={index}>
          <ListItemText>Item</ListItemText>
          <ListItemSecondaryAction>Action</ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  )
}

export default ReportsEditList
